var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-menu',_vm._b({on:{"input":_vm.update},scopedSlots:_vm._u([{key:"activator",fn:function({ attrs, on }){return [_c('div',_vm._g(_vm._b({staticClass:"activator"},'div',attrs,false),on),[_vm._t("activator")],2)]}}],null,true)},'v-menu',_vm.$props,false),[_vm._t("menu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }